export default {
    url: '/skill',
    template: '<ui-view></ui-view>',
    resolve: {
        classifiers: (ClassifierResource) => ClassifierResource.query({ pageSize: 0 }).$promise
    },
    abstract: true
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/user/skill/index.js